// React Thirty Party Library
import { TreeSelect } from "antd";

// Constants Library

// Components Library

// Handler Library

// Services Library

// Redux Actions

// Styles Library

const { SHOW_PARENT } = TreeSelect;

const FilterSelect = ({
  selection,
  selectedData,
  onChangeSelect,
  text,
  style
}) => {
  const allSelected = selection.length === selectedData.length;

  return (
    <>
      <TreeSelect
        treeCheckable
        showCheckedStrategy={SHOW_PARENT}
        value={selectedData}
        maxTagCount={allSelected ? undefined : "responsive"}
        onChange={onChangeSelect}
        placeholder={text}
        style={ allSelected ? style || { width: 250 } : { width: 120 }}
        treeData = {selection}
        popupMatchSelectWidth={false}
      />
    </>
  );
};

export default FilterSelect;
